import Announcement from '@/components/announcement';
import Concerts from '@/components/concerts';
import Layout from '@/layouts/layout';

export default function Home({events, album}) {
    return (
        <Layout>
            {album.data &&
                album.data.title &&
             (
                <Announcement album={album.data} />
            )}
            <Concerts concerts={events.data} />
        </Layout>
    );
}
